import { TablePagination } from "@merchant-webapp/components";
import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslocoPipe } from "@jsverse/transloco";
import { NgSelectComponent } from "@ng-select/ng-select";
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { PaginatorDirective } from "./paginator.directive";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "er-paginator",
  standalone: true,
  imports: [TranslocoPipe, NgSelectComponent, FormsModule, MatPaginatorModule, PaginatorDirective, MatIconModule],
  templateUrl: "./paginator.component.html",
  styleUrls: ["./paginator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// TODO: Connect pagination component directly to a store?
export class PaginatorComponent {
  // TODO: I think it's easier to have one big input property with all the options, instead of n inputs
  // Maybe a few inputs, not only one, but group where it makes sense, like pagination details
  // In my opinion, because the paginator will only be used in the context of a data table that will come with a store,
  // it would make sense to make this component smart and talk directly to the store
  // If we want customization, the store could be injected through a new custom injection_token that makes sure the service it is injecting at least has withPagination applied, but no other criteria, it would be the most "engineered solution", just wondering if it's not over engineered. Will leave it like this for now, just change the api a bit
  public readonly options = input<TablePagination>({} as TablePagination);

  @Input() defaultPageSize = 10;
  @Input() totalRecords!: number;
  @Input() pageSize!: number;
  @Input() pageIndex!: number;
  @Output() changePageSize: EventEmitter<number> = new EventEmitter<number>();
  @Output() changePageIndex: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  //   private defaultPageSettings = {
  //     previousPageIndex: this.pageIndex,
  //     pageSize: this.pageSize,
  //     length: this.totalRecords,
  //   };

  public prev() {
    this.changePageIndex.emit({
      pageSize: this.pageSize,
      pageIndex: this.pageIndex - 1,
      length: this.totalRecords,
    });
  }

  public next() {
    this.changePageIndex.emit({
      pageSize: this.pageSize,
      pageIndex: this.pageIndex + 1,
      length: this.totalRecords,
    });
  }
}
